import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { updateConversationSettings } from '~/modules/chat/api/update-conversation-settings.server';

export const UPDATE_CONVERSATION_SETTINGS_API =
    '/remix-api/chat/update-settings';

const FORM_DATA_SCHEMA = z.object({
    allowMessageRequests: z.boolean().nullish(),
    notificationSoundEnabled: z.boolean().nullish(),
});

/**
 * API endpoint to update the current user's conversation settings
 * @see {@link packages/web/app/modules/chat/hooks/use-conversation-settings.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await updateConversationSettings({
            context,
            allowMessageRequests: result.data.allowMessageRequests,
            notificationSoundEnabled: result.data.notificationSoundEnabled,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        const { __typename: _, ...conversationSettings } = response;

        return json({ conversationSettings });
    } catch (error) {
        logger.error(`Error in ${UPDATE_CONVERSATION_SETTINGS_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
